module.exports = __webpack_public_path__ + "static/media/foul-play-feature-banner-lg@1x.b7fa4892.jpg";